import React from "react";
import AdminLayout from "./AdminLayout";
import PlatformEconomySettings from "../../components/Admin/PlatformEconomySettings";

const EconomyPage = () => {
  return (
    <AdminLayout>
      <PlatformEconomySettings />
    </AdminLayout>
  );
};

export default EconomyPage;
